import React from 'react';
import { splitIntoSegments } from './sms-constants';
import styles from './SendMessageStep.module.css';

interface SMSPhoneMockupProps {
  text: string;
  senderName?: string;
}

export const SMSPhoneMockup: React.FC<SMSPhoneMockupProps> = ({
  text,
  senderName = 'Your Business',
}) => {
  const segments = splitIntoSegments(text);
  return (
    <div className={styles.phoneMockup}>
      <div className={styles.phoneScreen}>
        <div className={styles.phoneHeader}>{senderName}</div>
        <div className={styles.phoneBody}>
          {segments.length > 0 ? (
            segments.map((segment, segmentIndex) => (
              <p key={segmentIndex} className={styles.phoneBubble}>
                {segment}
              </p>
            ))
          ) : (
            <p className={styles.phoneEmptyText}>Your SMS will appear here...</p>
          )}
          <span className={styles.phoneTimestamp}>Just now</span>
        </div>
      </div>
    </div>
  );
};
